$(window).on('load', function () { // The form isn't available on the initial DOM; it gets loaded in by a script.
    // Mark labels of radio buttons as checked when their radio buttons are checked.
    $('.send-message-form input[type=radio]').click(function () {
        $(this).parent('label').addClass('checked').siblings('label').removeClass('checked');
    });
});